/** Fallback conversation id used when no live conversation id is available. */
export const PLACEHOLDER_CONVERSATION_ID = 'pending-conversation';

/**
 * Synthetic {@link SidekickError.code} the transport hooks emit when a
 * network-layer / transport failure surfaces (fetch reject, body read
 * abort, JSON parse failure, missing payload field, persistent
 * connection failure after the single retry). Distinct from any
 * BE-defined code: the orchestrator branches on this value to route
 * the failure to a toast (`onNetworkError`) instead of an inline
 * {@link ErrorEvent}.
 *
 * Centralized so transports (`useSidekickEventStream`,
 * `useSidekickSyncResponse`) and the orchestrator (`useConversation`)
 * cannot drift on the string literal.
 */
export const SYNTHETIC_TRANSPORT_ERROR_CODE = 'STREAM_TRANSPORT';
